<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="600"
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="blue">
        <v-btn v-if="$vuetify.breakpoint.xsOnly" icon @click.native="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <template v-if="!isLoading">{{ $t('message.vessel_crew', { vessel: vessel.name }) }}</template>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items v-if="$vuetify.breakpoint.xsOnly">
          <v-btn v-if="filteredRoleInVessels && filteredRoleInVessels.length" dark text @click.native="save">{{
            $t('message.save')
          }}</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <div class="blue" style="position: relative">
        <v-text-field
          v-if="
            !isLoading &&
              unboundVessel &&
              'undefined' !== typeof unboundVessel.roleInVessels &&
              unboundVessel.roleInVessels.length > 0
          "
          v-model="searchQuery"
          class="mx-3 mb-4 pa-0"
          flat
          :label="$t('message.search_by_name')"
          prepend-inner-icon="mdi-magnify"
          solo-inverted
          clearable
          dark
          hide-details
        ></v-text-field>
        <v-btn v-if="$vuetify.breakpoint.smAndUp" color="orange" dark absolute bottom right fab>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>

      <!--
      <v-card-title class="pt-0 pb-0">
        <v-text-field
          name="search"
          label="Search"
          single-line
          append-icon="search"
        ></v-text-field>
      </v-card-title>
      -->
      <v-card-text class="pa-0" style="height: 100%; min-height: 250px">
        <v-row v-if="isLoading" class="fill-height" align="center" justify="center">
          <div class="dialog-spinner mt-3">
            <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
          </div>
        </v-row>

        <div
          v-else-if="dialog"
          :class="{
            'pt-4': $vuetify.breakpoint.smAndUp,
            'pb-5': $vuetify.breakpoint.xsOnly
          }"
        >
          <v-btn v-if="$vuetify.breakpoint.xsOnly" color="orange" dark fixed bottom right fab>
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <v-form
            v-if="filteredRoleInVessels && filteredRoleInVessels.length > 0"
            ref="form"
            @submit.prevent="onSubmit(unboundVessel)"
          >
            <v-row
              v-for="item in filteredRoleInVessels"
              :key="item.id"
              align="center"
              class="mt-3 mx-3"
              :class="{ 'grey lighten-5 pa-3': $vuetify.breakpoint.xsOnly }"
              style="min-height: 52px"
            >
              <v-col cols="12" sm="6">
                <v-row align="center">
                  <v-avatar v-if="$vuetify.breakpoint.smAndUp" size="40" class="mr-3">
                    <img
                      v-if="item.user.image"
                      :src="item.user.image.contentUrl + '?x-request=html'"
                      :alt="item.user.firstName + ' ' + item.user.lastName"
                    />
                    <img v-else src="../../assets/no-img.svg" :alt="item.user.firstName + ' ' + item.user.lastName" />
                  </v-avatar>
                  <div>
                    {{ item.user.firstName }}
                    {{ item.user.lastName }}
                  </div>
                </v-row>
              </v-col>
              <div class="flex-grow-1"></div>
              <v-col cols="12" sm="6">
                <v-select
                  v-if="isAllowedVesselRole(item.vesselRole)"
                  v-model="item.vesselRole"
                  placeholder="No role in this vessel"
                  :items="allowedVesselRoles"
                  item-value="@id"
                  item-text="name"
                  :menu-props="{ maxHeight: '400' }"
                  class="pa-0 ma-0"
                  :clearable="true"
                ></v-select>
                <span v-else class="grey--text">{{ $t('message.' + item.vesselRole.name) }}</span>
              </v-col>
            </v-row>
          </v-form>
          <v-row v-else class="fill-height" align="center" justify="center">
            <div v-if="!searchQuery" class="empty-state-sm">
              <v-icon size="64" class="grey--text text--lighten-2">mdi-account-supervisor-circle</v-icon>
              <p class="grey--text">
                {{ $t('message.there_are_no_employees_yet') }}
              </p>
            </div>
            <div v-else class="empty-state-sm">
              <v-icon size="64" class="grey--text text--lighten-2">mdi-magnify</v-icon>
              <p class="grey--text">
                {{ $t('message.no_search_results') }}
              </p>
            </div>
          </v-row>
        </div>

        <v-dialog v-model="errorDialog" max-width="290">
          <v-card>
            <v-card-text>There was an error submitting the form</v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="green darken-1" text @click.native="errorDialog = false">Cancel</v-btn>
              <v-btn color="green darken-1" text @click.native="errorDialog = false">Try again</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="!isLoading" class="hidden-xs-only">
        <div class="flex-grow-1"></div>
        <v-btn color="grey" text @click.native="close">{{ $t('message.cancel') }}</v-btn>
        <v-btn v-if="filteredRoleInVessels && filteredRoleInVessels.length" color="orange" text @click.native="save">{{
          $t('message.save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    vessel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errorDialog: false,
      unboundVessel: {},
      searchQuery: null
    }
  },

  computed: {
    ...mapGetters({
      error: 'vessel/update/error',
      violations: 'vessel/update/violations',
      roleInVessels: 'roleinvessel/list/items',
      roleInVesselsLoading: 'roleinvessel/list/isLoading',
      roleInOrganizations: 'roleinorganization/list/items',
      roleInOrganizationsLoading: 'roleinorganization/list/isLoading',
      vesselRoles: 'vesselrole/list/items',
      vesselRolesLoading: 'vesselrole/list/isLoading'
    }),
    dialog: {
      // getter
      get: function() {
        return this.show
      },
      // setter
      set: function(show) {
        if (false === show) {
          this.close()
        }
      }
    },

    isLoading: function() {
      return this.roleInVesselsLoading || this.roleInOrganizationsLoading || this.vesselRolesLoading
    },

    filteredRoleInVessels: function() {
      if (!this.unboundVessel || !this.unboundVessel.roleInVessels) {
        return null
      }
      let filteredRoleInVessels = this.unboundVessel.roleInVessels
      if (this.searchQuery) {
        filteredRoleInVessels = this.unboundVessel.roleInVessels.filter(roleInVessel => {
          const fullName = roleInVessel.user.firstName + ' ' + roleInVessel.user.lastName
          return fullName.toLocaleLowerCase().includes(this.searchQuery.toLowerCase())
        })
      }
      return filteredRoleInVessels
    },

    allowedVesselRoles: function() {
      if (!this.vesselRoles) {
        return
      }

      // If is shipowner return all vessel roles
      if (this.$security.isGranted(this.vessel.organization, 'ROLE_SHIPOWNER')) {
        let vesselRoles = this.vesselRoles
        vesselRoles.forEach(vesselRole => {
          vesselRole.name = this.$t('message.' + vesselRole.name)
        })
        return vesselRoles
      }

      // Search children for user vessel role in current vessel
      const user = this.$security.getUser()
      const vesselRoleInCurrentVessel = user.roleInVessels.filter(roleInVessel => {
        return roleInVessel.vessel['@id'] === this.vessel['@id']
      })[0].vesselRole

      let childrenVesselRoles = []

      this.vesselRoles.forEach(vesselRole => {
        if (vesselRoleInCurrentVessel['@id'] === vesselRole['@id']) {
          // recursive get children from the vesselRole
          this.getChildrenFromVesselRole(vesselRole, childrenVesselRoles)
        }
      })

      childrenVesselRoles.forEach(vesselRole => {
        vesselRole.name = this.$t('message.' + vesselRole.name)
      })

      return childrenVesselRoles
    }
  },

  watch: {
    // Retrieve all resources on dialog open and reset on dialog close
    dialog: function(dialog) {
      if (dialog) {
        this.roleInVesselsGetPage('/role_in_vessels?pagination=false&vessel=' + this.vessel['@id'])
        this.roleInOrganizationsGetPage(
          '/role_in_organizations?pagination=false&organization=' + this.vessel.organization['@id']
        )
        this.vesselRolesGetPage()
      } else {
        this.resetVessel()
      }
    },

    created: function(created) {
      if (!created) {
        return
      }

      this.close()
    },
    error: function(error) {
      if (!error) {
        return
      }

      this.errorDialog = true
    },
    isLoading: function(isLoading) {
      if (isLoading) {
        return
      }

      let _this = this

      this.unboundVessel = JSON.parse(JSON.stringify(this.vessel))

      this.unboundVessel.organization.roleInOrganizations = JSON.parse(JSON.stringify(this.roleInOrganizations))
      this.unboundVessel.roleInVessels = JSON.parse(JSON.stringify(this.roleInVessels))

      this.roleInOrganizations.forEach(function(roleInOrganization) {
        if ('ROLE_MEMBER' === roleInOrganization.organizationRole.name) {
          let exists = false
          _this.unboundVessel.roleInVessels.forEach(function(roleInVessel) {
            if (roleInOrganization.user['@id'] === roleInVessel.user['@id']) {
              exists = true
            }
          })

          if (!exists) {
            _this.unboundVessel.roleInVessels.push({
              user: roleInOrganization.user,
              vessel: _this.unboundVessel['@id'],
              vesselRole: {}
            })
          }
        }
      })
    }
  },

  methods: {
    ...mapActions({
      roleInVesselsGetPage: 'roleinvessel/list/default',
      roleInOrganizationsGetPage: 'roleinorganization/list/default',
      vesselRolesGetPage: 'vesselrole/list/default',
      retrieveVessel: 'vessel/update/retrieve',
      resetVessel: 'vessel/update/reset',
      updateVessel: 'vessel/update/update'
    }),

    isAllowedVesselRole(vesselRole) {
      if ('undefined' === typeof vesselRole || !vesselRole) {
        return true
      }

      let isAllowed = false

      const vesselRoleId = 'string' === typeof vesselRole ? vesselRole : vesselRole['@id']

      this.allowedVesselRoles.forEach(allowedVesselRole => {
        if (vesselRoleId === allowedVesselRole['@id']) {
          isAllowed = true
        }
      })

      if (!vesselRoleId) {
        isAllowed = true
      }

      return isAllowed
    },

    getChildrenFromVesselRole(vesselRole, childrenVesselRoles) {
      if (vesselRole.children.length > 0) {
        vesselRole.children.forEach(childVesselRole => {
          childrenVesselRoles.push(childVesselRole)
          this.getChildrenFromVesselRole(childVesselRole, childrenVesselRoles)
        })
      } else {
        return childrenVesselRoles
      }
    },

    close() {
      this.$parent.showManageDialog = false
    },

    save() {
      this.onSubmit(this.unboundVessel)
    },

    onSubmit(unboundVessel) {
      let vessel = JSON.parse(JSON.stringify(unboundVessel))
      vessel.roleInVessels = vessel.roleInVessels.filter(function(roleInVessel) {
        if ('undefined' === typeof roleInVessel.vesselRole) {
          roleInVessel.vesselRole = {}
        }
        return roleInVessel.vesselRole['@id'] || 'string' === typeof roleInVessel.vesselRole
      })

      this.vessel.roleInVessels = vessel.roleInVessels

      this.$store.commit('vessel/update/VESSEL_UPDATE_SET_RETRIEVED', this.vessel)

      this.updateVessel()

      this.$parent.showManageDialog = false
    }
  }
}
</script>
